// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"KP-z","inlineTitle":"LP-z","sponsoredAdsWrapper":"MP-z","marketplaceRecosWrapper":"NP-z"};